import { render, staticRenderFns } from "./UI-widget-boxes.vue?vue&type=template&id=1db66318&"
import script from "./UI-widget-boxes.vue?vue&type=script&lang=js&"
export * from "./UI-widget-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports